import FileUploader from './FileUploader.vue'

export default FileUploader